// src/utils/emailLogo.js
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

let cachedEmailLogo = null;

export const getEmailLogo = async () => {
  if (cachedEmailLogo) return cachedEmailLogo;
  
  try {
    const logosRef = doc(db, "logos", "xrSCDlcVzp10becG8bnW");
    const logosSnap = await getDoc(logosRef);
    
    if (logosSnap.exists()) {
      const data = logosSnap.data();
      cachedEmailLogo = data.emailLogo || data["email logo"] || "https://i.postimg.cc/023xvzzm/vbt-logo-2.png";
      return cachedEmailLogo;
    }
    return "https://i.postimg.cc/023xvzzm/vbt-logo-2.png";
  } catch (err) {
    console.error("Error fetching email logo:", err);
    return "https://i.postimg.cc/023xvzzm/vbt-logo-2.png";
  }
};